module.exports = __webpack_public_path__ + "static/media/YM38_1.9791dc19.jpg";